// extracted by mini-css-extract-plugin
export var externalLink = "_cu-0";
export var internalLinkLabel = "_cu-1";